<script>
import { Doughnut, mixins } from 'vue-chartjs';
const { reactiveProp } = mixins;

export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  props: ['options'],
  mounted() {
    this.addPlugin({
      id: 'percentage-labels',
      afterDatasetsDraw: (chart) => {
        const ctx = chart.ctx;
        chart.data.datasets.forEach((dataset, i) => {
          const meta = chart.getDatasetMeta(i);
          if (!meta.hidden) {
            meta.data.forEach((element, index) => {
              // Calculate percentage
              const total = dataset.data.reduce((acc, curr) => acc + curr, 0);
              const value = dataset.data[index];
              const percentage = total > 0 ? ((value / total) * 100).toFixed(1) + '%' : '0.0%';

              // Only show if > 5% to avoid clutter
              if (value / total < 0.05) return;

              // Draw
              ctx.fillStyle = '#fff';
              const fontSize = 11; // Slightly smaller to fit
              const fontStyle = 'bold';
              const fontFamily = 'Helvetica Neue, Arial';
              ctx.font = `${fontStyle} ${fontSize}px ${fontFamily}`;
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';

              const position = element.tooltipPosition();
              
              // Add drop shadow/outline for readability on all colors
              ctx.save();
              ctx.shadowColor = 'rgba(0, 0, 0, 0.5)';
              ctx.shadowBlur = 3;
              ctx.fillText(percentage, position.x, position.y);
              ctx.restore();
            });
          }
        });
      }
    });
    this.renderChart(this.chartData, this.options);
  }
};
</script>
